import { Link, useLocation } from "react-router-dom";
import AppLayout from "@/components/feature/AppLayout";

export default function NotFound() {
  const location = useLocation();

  return (
    <AppLayout>
      <div className="px-4 md:px-6 py-16 flex flex-col items-center text-center">
        <span className="w-16 h-16 rounded-full bg-accent-100 text-accent-700 flex items-center justify-center">
          <i className="ri-compass-3-line text-3xl" />
        </span>
        <h1 className="mt-5 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
          这一页迷路了
        </h1>
        <p className="mt-2 text-[13px] text-foreground-600 max-w-md leading-relaxed">
          我们没有找到 <span className="text-foreground-900">{location.pathname}</span> 对应的页面。
          可能是链接输入有误，或者这部作品已经调整了位置。
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
          <Link
            to="/"
            className="h-9 px-4 rounded-md bg-primary-500 text-background-50 text-[13px] flex items-center gap-1.5 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-home-5-line" />
            回到首页
          </Link>
          <Link
            to="/list"
            className="h-9 px-4 rounded-md border border-background-300 text-foreground-800 text-[13px] flex items-center gap-1.5 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-filter-3-line" />
            浏览全部动漫
          </Link>
          <Link
            to="/search"
            className="h-9 px-4 rounded-md border border-background-300 text-foreground-800 text-[13px] flex items-center gap-1.5 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-search-line" />
            搜索动漫
          </Link>
        </div>
      </div>
    </AppLayout>
  );
}